import { Lock } from 'lucide-react'

import { Badge } from '@/components/ui/badge'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'

import { CAREFORCE_ONLY_HINT, CAREFORCE_ONLY_LABEL } from './rubricTypes'

/** Marks one rubric's results the viewed org's customers don't see. Needs a
 *  `TooltipProvider` above it. */
export function CareforceOnlyBadge() {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Badge
          variant="outline"
          tabIndex={0}
          className="text-muted-foreground shrink-0 gap-1 px-1.5 py-0 text-[11px]">
          <Lock aria-hidden className="size-3" />
          {CAREFORCE_ONLY_LABEL}
        </Badge>
      </TooltipTrigger>
      <TooltipContent>{CAREFORCE_ONLY_HINT}</TooltipContent>
    </Tooltip>
  )
}
